<template>
<div>
  <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h4 class="h no-margin-bottom">Genel tanımlamalar</h4>
       <div class="right-menu list-inline no-margin-bottom">
        <button type="submit" @click="$router.back()" class="btn submit bg-dark text-light">Geri Dön</button>
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
  <div class="container-fluid">
  <div class="row">
              <div class="col-lg-6 col-12">
                <div class="block">
                    <div class="block-body">
                      <form @submit.prevent="sendNewPost">
                        <div class="form-group">
                          <label class="form-control-label">Kodu</label>
                          <input name="title" type="text" class="form-control" v-model="newPost.kodu" />
                        </div>
                        <div class="form-group">       
                          <label class="form-control-label">Alias</label>
                          <input name="title" type="text" class="form-control" v-model="newPost.alias" />
                        </div>
                        <div class="form-group">       
                          <input type="submit" :disabled="progres.inprogres" :value="mode" class="btn btn-primary w-100">
                        </div>
                      </form>
                    </div>
                  </div>
              </div>
              <div class="col-lg-6">
                <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          
                          <th>Kodu</th>
                          <th>Alias</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(post,index) in posts" :key="index">
                          
                          <td>{{post.kodu}}</td>
                          <td>{{post.alias}}</td>
                          <td><button @click="aktar(post.kodu,post.alias,post.id)" class="btn btn-dark btn-sm">Düzenle</button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>       
            </div>
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <div class="container-fluid text-center">
                    Sistem Hatası : {{ errors.length }}  {{ errors.message }}        
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>

      </div>
</template>

<script>
  export default {

    async created() {
      this.progres.inprogres = true

     this.getPostsAsync(this.newPost.table,'anakod','cihazaltgrup','altkod');
    },
    data() {
      return {
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        } ,
        posts: [],
        errors: [],        
        kodu : '',
        alias : '',
        mode:'Ekle',
        idsi:'', // güncelleme için satır id
        newPost: {
          kodu: '',
          alias:'',
          firma : this.$request.ayar().firmaid,
          table : this.$route.params.table,
        },
        source:this.$store.getters.getsource,
        kayittipi:0
    
      };
    },
    methods: {
        yetki: function(){
          if (this.$helper.sayfayetki(319839)){
             this.getPostsAsync(this.newPost.table)
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
        aktar(kodu,alias,id){
            this.idsi = id;
            this.newPost.kodu = kodu;
            this.newPost.alias = alias;
            this.kayittipi = 1
            this.mode = "Düzenle ( Yeni kayıt için sayfayı yenileyin )"
        },
        getPostsAsync(tables,tablesKod,node,nodeKod){

          if (tables == 'cihazgrup') {
            this.$request.post("servis/api", {q:'cihaz_list',where:{},isim:this.$request.ayar().f1})
            .then(res => {
              console.log(res.data)
              this.$request.gruplama(res.data,tables,tablesKod,node,nodeKod).then(res=>{
              this.posts = res
              this.progres.inprogres = false

            })
            })

          }
          else if (tables == 'cd') {
            this.$request.post("servis/api", {q:'cd',where:{},isim:this.$request.ayar().f1})
            .then(res => {
              this.posts = res.data;
              this.progres.inprogres = false

            })

           }

          else {
            this.$request.get("servis/define/"+this.newPost.firma+"/"+tables)
            .then(res => {
              this.posts = res.results;
              this.progres.inprogres = false

            })
          }
          //local db

        },
     // async getPostsAsync(tables) {
   //     try {
   //       const response = await this.$axios.get("/define/"+this.newPost.firma+"/"+tables);
   //       this.posts = response.data.results;
   //     } catch (error) {
  //        this.errors.push(error);
  //      }
  //    },
      sendNewPost() {
        if(this.newPost.table=="cihazgrup") {
          this.$swal("Farklı Kaynak, işlem yapılamaz")

        }
        else if (this.newPost.table=='cd') {
          var obje = {
            tablo:[{ No:246, KayitTipi: this.kayittipi }],
            kayit:[{ cdr_kod:this.newPost.kodu, cdr_isim:this.newPost.alias }]
            //kayit:[ { cdr_kod:this.posts[0].kodu, cdr_isim:this.posts[0].alias },{ cdr_kod:this.newPost.kodu, cdr_isim:this.newPost.alias }]

          }
          this.$request.post("servis/api/add", {obje:obje,isim:this.$request.ayar().f1})
            .then(res => {
              console.log(res)
              if ( res.status == 200) {
                this.$swal("İşlem Başarılı")
                this.progres.inprogres = false
              }
              else {
                this.$swal(res.msg)
                this.progres.inprogres = false
              }
            })
        }
        else {
        if (this.newPost.kodu && this.newPost.alias){
          this.progres.inprogres = true
          if (this.mode==="Ekle")
          {
            this.$request.post("servis/define/",this.newPost )
            .then( res =>{
             this.$swal("Kayıt Ekleme Başarılı")
             this.getPostsAsync(this.newPost.table)
            }
          )
        .catch(err => this.$swal(err))
        }
        else{
          let data = Object.assign(this.newPost,{id:this.idsi})
            this.$request.post("servis/defineUpdate/",data )
            .then( res =>{
             this.$swal("Düzenleme Başarılı")
             this.getPostsAsync(this.newPost.table)

            }
          )
        .catch(err => this.$swal(err))          
        }
        this.progres.inprogres = false;
        }
        else{
          this.$swal("Girdileri Kontrol Et")
        }
        }


      },     
    },
    watch : {
        "$route.params.table":function(val) {
          this.getPostsAsync(val)
        },
      },    
  };
</script>


// WEBPACK FOOTER //
// src/views/defines.vue